<template>
  <div class="model-thumbnail">
            <div class="model-picture-wrapper selection"
                 :title="$t('product-list.configureModelTooltip')"
                 @click="searchByMaxStklId(products.id), setProductBreadcrumb(products.name)">
                    <img class="model-picture" :src="this.image" />
            </div>
            <b-dropdown id="customDropdown" :text="products.name" block right split
                        @click="searchByMaxStklId(products.id), setProductBreadcrumb(products.name)">
                <b-dropdown-item class="font-size-for-dropdown" :productId="products.id"
                                 @click="searchByMaxStklId(products.id), setProductBreadcrumb(products.name)">
                    <b-icon icon="gear-fill" class="custom-icons"/>{{$t('product-list.configurator')}}
                </b-dropdown-item>
                <b-dropdown-divider v-if="isSuchenInMerkmalenErlaubt && !isUserExtern"></b-dropdown-divider>
<!--                <b-dropdown-item v-if="isSuchenInMerkmalenErlaubt" :href="apiUrl + '/products/search/model/' + products.id" class="font-size-for-dropdown" :productId="products.id">-->
<!--                        <b-icon icon="search" class="custom-icons"/>{{$t('product-list.searchInAttrsStkl')}}-->
<!--                </b-dropdown-item>-->
                <b-dropdown-item v-if="!isUserExtern" :href="apiUrl + '/vorzugswerte/' + products.id" class="font-size-for-dropdown" :productId="products.id">
                    <b-icon icon="star" class="custom-icons" style="color: #007bff;"/>{{$t('product-list.recommendedAttrs')}}
                </b-dropdown-item>
            </b-dropdown>
  </div>
</template>

<script>
    import url from "@/rest/url";
    import axios from "axios";
    import searchByMaxStklId from '../../mixins/searchByMaxStklId';

    export default {
        name: "ProductList",
        props: [ 'products', 'crumb'],
        mixins: [searchByMaxStklId],
        data: function() {
            return {
                image: '',
                apiUrl: '',
                initModelError: ''
            }
        },
        computed: {
            isUserExtern: function () {
                return this.$store.getters.getUserData.extern;
            },
            isSuchenInMerkmalenErlaubt: function () {
                return this.$store.getters.getUserData.suchenInMerkmalenErlaubt
            }
        },
        created() {
            this.getImagePath(this.products.id);
            this.setApiLocation();
        },
        methods: {
                async getImagePath(modelId) {
                    axios.get(url.apiLocation +'/pictures/'+ modelId)
                        .then(response => {
                            if(response.status == 200){
                                this.image = response.config.url
                            } else {
                                this.image = this.loadDefaultImage()
                            }
                        }).catch(
                            this.image = this.loadDefaultImage()
                        );
                },
                loadDefaultImage() {
                    return require(`@/assets/images/noImage_` + this.$i18n.locale + `.gif`);
                },
                setApiLocation() {
                       this.apiUrl = url.apiLocation
                },
                setProductBreadcrumb: function (productName) {
                  let crumbie = this.crumb.split('/');
                  let finalCrumb = crumbie[0] + ' / '  + productName.replace('/',' / ');
                  return this.$store.dispatch('setProductBreadcrumb', finalCrumb);
                },
            },
    }
</script>

<style scoped>
    .custom-icons{
        color: #000000;
        margin-right: 6px;
        margin-bottom: 2px;
        vertical-align: top;
        width: 15px;
        height: 15px;
    }

    .font-size-for-dropdown {
        font-size: 14px;
    }
    .model-thumbnail {
        width: auto;
        min-width: 200px;
        padding: 10px;
    }
    .model-picture-wrapper {
        width: auto;
        max-width: 200px;
        height: auto;
        max-height: 100px;
        display: block;
    }
    .model-picture {
        max-width: 200px;
        height: auto;
        max-height: 100px;
        display: block;
        margin-right: auto;
        margin-left: auto;
        margin-bottom: 10px;
    }

   /deep/ #customDropdown > button{
      border-radius: 0px;
      border-color: #0093d7;
      background-color: transparent;
      color: black;
    }

   /deep/ #customDropdown  > button:hover{
      background-color: #0081BD;
      color: white;
    }

    .selection { cursor: pointer;}
</style>